<template>
    <div style="width:85%;margin:auto;padding-top:10px;color:#7b7c87">
        <v-layout row wrap>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;padding-bottom:2px !important"><!--Row #1-->
                <v-layout row wrap>
                    <v-flex xs12 sm12 md10 lg10 xl10 style="padding:15px;">
                    <div style="padding-top:23px;font-weight:bolder;font-size:20px">مدیریت نظرات</div>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px;">
            <v-card>
                <v-card-text>
                    <v-data-table :loading="loadingInvoices" :items="dtData" :headers="dtHeaders">
                        <template v-slot:[`item.paymentType`]="{ item }">
                            <span v-if="item.paymentType == 1">آنلاین</span>
                           
                        </template>
                        <template v-slot:[`item.state`]="{ item }">
                            <v-chip small v-if="item.state == 1">جدید</v-chip>
                            <v-chip small v-if="item.state == 2"> تایید شده</v-chip>
                        </template> 
                        <template v-slot:[`item.operation`]="{ item }">
                            <v-btn small v-if="item.state == 1" icon color="green"  @click="AcceptComment(item.id)">تایید</v-btn> &nbsp;
                            <v-btn small icon color="red"  @click="DeleteComment(item.id)">حذف</v-btn>

                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
        </v-layout>
    </div>
    
</template>

<script>
const ApiUrl = require("../../constant/apiurl");
const MSGHNDL = require("../../constant/MessageHandler");

const axios = require('axios');
import JsonExcel from 'vue-json-excel'
import { async } from 'q';
export default {
    components:{
        JsonExcel
    },
    name:"comments",
    data:()=>({
        sStatus:-1,
        PayTypeFilter:0,
        dtHeaders:[
            {text:"موجودیت ",value:"etitle",sortable:true,align:"right"},
            {text:"کاربر",value:"user",sortable:true,align:"right"},
            {text:"پست الکترونیکی",value:"email",sortable:true,align:"right"},
            {text:"تاریخ / ساعت ",value:"date",sortable:true,align:"right"},
            {text:"متن",value:"body",sortable:true,align:"right"},
            {text:"وضعیت",value:"state",sortable:true,align:"right"},
            {text:"عملیات",value:"operation",sortable:true,align:"right"},
        ],
        ProductTableHeaders:[
            {text:"#",value:"counter",sortable:true,align:"right"},
            {text:"عنوان محصول",value:"Title",sortable:true,align:"right"},
            {text:"رنگ",value:"Color",sortable:true,align:"right"},
            {text:"گارانتی",value:"Warranty",sortable:true,align:"right"},
            {text:"تعداد ",value:"Count",sortable:true,align:"right"},
            {text:"قیمت",value:"Price",sortable:true,align:"right"},
            {text:"جمع",value:"Total",sortable:true,align:"right"},
        ],
        dtData:[],
        prodItems:[],
        Repository:[],
        ExcelFields:{
            'شماره فاکتور':'code',
            'نوع ارنام و نام خانوادگی':'user',
            'جمع مبلغ':'sumProducts',
            'هزینه ارسال':'shippingCost',
            'مبلغ کل':'sum',
            'کد تخفیف':'couponCode',
            'درصد تخفیف':'couponPerc',
            'نوع پرداخت':'paymentType',
            'تاریخ پرداخت':'paymentDate',
            'وضعیت':'status'
        },
        schUser:null,
        schPhone:null,
        schSdate:null,
        schEdate:null,
        schMail:null,
        inSearching:false,
        OperationItem:[],
        AcceptDialog:false,
        DissmissDialog:false,
        InAcceptingRequest:false,
        dismissReason:"",
        InDismissingRequest:false,
        RequestStatusReportDialog:false,
        ProductsTableDialog:false,
        ProductsTableItems:[],
        ProductsTableHeader:[
            {text:"موجودیت ",value:"etitle",sortable:true,align:"right"},
            {text:"کاربر",value:"user",sortable:true,align:"right"},
            {text:"پست الکترونیکی",value:"email",sortable:true,align:"right"},
            {text:"تاریخ / ساعت ",value:"quantity",sortable:true,align:"right"},
            {text:"متن",value:"priceWODiscount",sortable:true,align:"right"},
            {text:"جمع",value:"Total",sortable:true,align:"right"},
        ],
        selectedItem:{reciption:null},
        TicketDialog:false,
        Ticket:[],
        Entity:0,
        RegTicketRespLoading:false,
        ticketResponse:"",
        loadingInvoices:false
    }),
    created(){
        this.loadSuggestions();
    },
    methods:{
        async AcceptComment(id)
        {
            let vm = this;
            var url=ApiUrl.AcceptComment+'/'+id;
            await axios.post(url)
                .then( async function (res) {
                    console.log(res);
                    if(res.data.status)
                    {
                       await vm.loadSuggestions();
                       
                    }
                })
                .catch(function (error) {
                
                console.log(error);
                });
        },    
         async DeleteComment(id)
        {
            let vm = this;
            var url=ApiUrl.DeleteComment+'/'+id;
            await axios.post(url)
                .then( async function (res) {
                    console.log(res);
                    if(res.data.status)
                    {
                       await vm.loadSuggestions();
                       
                    }
                })
                .catch(function (error) {
                
                console.log(error);
                });
        },
        factorStatus(state)
        {
            if(state == 1)
            {
                return "پرداخت نشده / ناموفق";
            }
            if(state == 2)
            {
                return "پرداخت شده";
            }
            if(state == 3)
            {
                return "تحویل شد";
            }
        },
        async RegisterResponse()
        {
            var vm = this;
            let Model = {};
            Model.T_Cid = vm.Entity;
            Model.T_Userid = 0;
            Model.T_Body = vm.ticketResponse;
            await axios.post(ApiUrl.AddTicket, Model)
            .then(async function (res) {
                var data = res.data;
                if (data.status) {
                    MSGHNDL.OK(data.msg);
                    vm.ticketResponse = "";
                    await vm.LoadTickets();
                }
                else {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch(function (err) {
                console.error(err);
            });
        },
        async DisplayTicket(item)
        {
            let vm = this;
            vm.TicketDialog = true;
            vm.Entity = item.code;
            await vm.LoadTickets();
        },
        async LoadTickets()
        {
            let vm = this;
            await axios.post(ApiUrl.Ticket.GetEntity+"/"+vm.Entity)
            .then((res)=>{
                var data = res.data;
                if(data.status)
                {
                    vm.Ticket = data.data;
                }
            })
            .catch((err)=>{console.error(err)});
        },
        DisplayStatusReport(item)
        {
            let vm = this;
            vm.AcceptDialog = true;
            vm.prodItems = item.Products;
            
        },
        DisplayProducts(item)
        {
            let vm = this;
            vm.ProductsTableDialog = true;
            vm.ProductsTableItems = item.products;
            vm.selectedItem = item;
        },
        async DismissRequest()
        {
            let vm = this;
            vm.InDismissingRequest = true;
            let url = "http://derics.barayand.net/api/request/DissmisWalletRequest";
            let data = new FormData();
            let model = {};
            model.RequestId = vm.OperationItem.RequestId;
            model.Reason = vm.dismissReason;
            data.append("DissmisModel",JSON.stringify(model));
            await axios.post(url,data)
            .then(async (res)=>{
                console.log(res);
                if(res.data.status)
                {
                    vm.DissmissDialog = false;
                    await vm.loadSuggestions();
                }
                vm.InDismissingRequest = false;
            })
            .catch((err)=>{vm.InDismissingRequest = false;console.log(err);});
        },
        async AcceptRequest()
        {
            let vm = this;
            vm.InAcceptingRequest = true;
            let url = "http://derics.barayand.net/api/request/AcceptWalletRequests";
            let data = new FormData();
            data.append("RequestId",vm.OperationItem.RequestId);
            await axios.post(url,data)
            .then(async (res)=>{
                console.log(res);
                if(res.data.status)
                {
                    vm.AcceptDialog = false;
                    await vm.loadSuggestions();
                }
                vm.InAcceptingRequest = false;
            })
            .catch((err)=>{vm.InAcceptingRequest = false;console.log(err);});
        },
        DisplayDismissDialog(item)
        {
            let vm = this;
            vm.OperationItem = item;
            vm.DissmissDialog = true;
        },
        DisplayAcceptDialog(item)
        {
            let vm = this;
            vm.OperationItem = item;
            vm.AcceptDialog = true;
        },
        async searchSuggestion()
        {
            let vm = this;
            vm.sStatus = 2;
            let data = {};
            if(vm.schUser != null)
            {
                data.User = vm.schUser;
            }
            if(vm.schPhone != null)
            {
                data.Phone = vm.schPhone;
            }
            if(vm.schSdate != null)
            {
                data.StartDate = vm.schSdate;
            }
            if(vm.schEdate != null)
            {
                data.EndDate = vm.schEdate;
            }
            if(vm.schMail != null)
            {
                data.Email = vm.schMail;
            }

                let sheet = {};
                sheet.searchModel = data; 
                var url="http://derics.barayand.net/api/setting/communication/searchConsultation";
                const config = 
                {
                    
                    url:url,
                    method: 'post',
                    data:sheet
                }
                await axios(config)
                    .then(function (res) {
                       
                        // vm.inUploading = false;
                        if(res.data.status)
                        {
                        vm.dtData = res.data.data;
                        vm.Repository = res.data.data;
                            // vm.documentFile = res.data.data;
                        }
                    })
                    .catch(function (error) {
                    
                    console.log(error);
                    });
            
        },
        async PayFilterChanged(e)
        {
            let vm = this;
           let f = e;
           vm.status = 0;
           if(f == 0)
           {   
                
                vm.dtData = vm.Repository;
          
               
           }
           else
           {
                vm.dtData = await vm.Repository.filter(({PayTypeBool})=>PayTypeBool == f );
           }
        },
        async filterChanged(e)
        {
           let vm = this;
           vm.PayTypeFilter = 0;
           let f = e;
           if(f == -1)
           {   
                
                vm.dtData = vm.Repository;
          
               
           }
           else
           {
                vm.dtData = await vm.Repository.filter(({StatusBool})=>StatusBool == f );
           }
        },
        async loadSuggestions()
        {
            let vm = this;
            var url=ApiUrl.LoadComments;
            vm.loadingInvoices = true;
            await axios.post(url)
                .then(function (res) {
                    vm.loadingInvoices = false;
                    console.log(res);
              
                    if(res.data.status)
                    {
                       vm.dtData = res.data.data;
                       vm.Repository = res.data.data;
                    }
                })
                .catch(function (error) {
                vm.loadingInvoices = false;
                console.log(error);
                });
        }
    }
}
</script>